import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const tableCellVariants = tv({
  base: "px-6 py-4 align-middle text-sm text-content",
});

export const TableCell = ({ className, ...props }: ComponentProps<"td">) => {
  return <td className={tableCellVariants({ className })} {...props} />;
};
